export default __webpack_public_path__ + "static/media/plain-sticker-8.8c243b60.png";